import { render, staticRenderFns } from "./FotoFrente.vue?vue&type=template&id=247bf7b8&scoped=true&"
import script from "./FotoFrente.vue?vue&type=script&lang=js&"
export * from "./FotoFrente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247bf7b8",
  null
  
)

export default component.exports